"use client"
import React, { useState, useEffect } from "react";
import Image from "react-bootstrap/Image";
import useApi from "@/components/api/useApi";
import Card from "react-bootstrap/Card";
import { useMediaQuery } from "react-responsive";

import "@/components/shared/UralityImage.css";

const UralityImage = ({
  src,
  imageId,
  base64,
  maxWidth,
  maxHeight,
  thumbnail,
  size,
  sizeStyle,
  brightness,
  addClass,
  tag,
  type,
  children
}) => {
  const isUrl = url => {
    var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    var regex = new RegExp(expression);
    return url.match(regex);
  };

  const isSm = useMediaQuery({ query: "(max-width: 576px)" });
  const isMd = useMediaQuery({ query: "(max-width: 768px)" });
  const isLg = useMediaQuery({ query: "(max-width: 1024px)" });
  const isXl = useMediaQuery({ query: "(max-width: 1440px)" });

  const [url, setUrl] = useState(null);
  const [external, setExternal] = useState(false);
  const api = useApi();

  const [base64Id, setBase64Id] = useState("null");

  useEffect(() => {
    if (base64) {
      setUrl(base64);
    } else {
      if (imageId != null && imageId !== "") {
        setBase64Id(Buffer.from(imageId).toString("base64"));
        // console.log(imageId, isUrl(imageId));
        if (base64) {
          setUrl(base64);
        } else if (isUrl(imageId)) {
          setUrl(imageId);
          setExternal(true);
        } else {
          if (maxWidth == null) {
            let responsiveSize = "xl";

            if (thumbnail) responsiveSize = "thumb";
            else if ((size && size === "sm") || isSm) responsiveSize = "sm";
            else if ((size && size === "md") || isMd) responsiveSize = "md";
            else if ((size && size === "lg") || isLg) responsiveSize = "lg";
            else responsiveSize = "xl";

            api.getResponsiveImage(imageId, responsiveSize).then(url => {
              setUrl(url);
            });
          } else {
            brightness = brightness != null ? brightness : 1.0;
            api.getImage(imageId, maxWidth, maxHeight, brightness).then(url => {
              setUrl(url);
            });
          }
        }
      }
    }
  }, [imageId, base64]);

  let img;

  if (url == null) {
    return (
      <div
        className={
          type === "roundedCircle" ? "img-missing-rounded" : "img-missing"
        }
      >
        {children}
      </div>
    );
  } else {
    if (tag === "Image") {
      if (type === "roundedCircle") {
        img = <Image src={url} alt={"..."} roundedCircle />;
      } else {
        img = <Image src={"" + url} alt={"..."} style={sizeStyle} />;
      }
    } else if (tag === "Card.Img") {
      img = <Card.Img src={"" + url} alt={"..."} style={sizeStyle} />;
    } else {
      img = <Image src={"" + url} alt={"..."} />;
    }
    return (
      <div
        className={`urality-image ${addClass} ${
          external ? "external-image" : ""
        }`}
        id={`urality-image-${base64Id}`}
      >
        {img}
        {children}
      </div>
    );
  }
};

export default UralityImage;
